import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { UserComponent } from './user/user.component';
import { ChannelsComponent } from './channels/channels.component';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastsContainer } from './notification/toasts-container.component';
import { ProcessAutoComponent } from './websocket/process-auto.component';

@NgModule({
  declarations: [UserComponent, ChannelsComponent, ToastsContainer],
  imports: [CommonModule, NgbDropdownModule, NgbToastModule],
  exports: [UserComponent, ChannelsComponent, ToastsContainer],
})
export class WidgetModule {}
